import React from 'react'
import MainBody from '../Components/AppComponent/MainBody'
import Navbar from '../Components/AppComponent/Navbar'
import Sidenav from '../Components/AppComponent/Sidenav'
import './css/Dashboard.css'

const Dashboard = () => {
  return (
    <>
        <div className="primary" id="dashboard">
            <Navbar />
            <div className="row">
                <div className="col-lg-3">
                    <Sidenav />
                </div>
                <div className="col-lg-9 col-sm-12 bg-primary" style={{height: 'auto'}}>
                    <MainBody />
                </div>
            </div>
        </div>
    </>
  )
}

export default Dashboard